const getGoogleFonts = fonts => {
  const defaultFont = 'Rubik:wght@300;400&display=swap';
  const { googleFonts = '' } = fonts;
  return googleFonts || defaultFont;
};

export default getGoogleFonts;
